import { formatGrowthRate, formatKeyValue } from '#formatting'

import createTimelineRecord from '../timeline/createTimelineRecord'
import TimelineGenerator from './TimelineGenerator'
import type { GenerationResult } from './types'

class TransactionGenerator extends TimelineGenerator {
  _generate(year: number): GenerationResult {
    const valueWithGrowth = this.record.projectedValue(year)

    return {
      timeline: [
        createTimelineRecord({
          year,
          value: valueWithGrowth,
          description: this.description(year, valueWithGrowth),
          financialRecord: this.record,
        }),
      ],
      finalValue: valueWithGrowth,
    }
  }

  private description(year: number, valueWithGrowth: number): string {
    const growthAmount = valueWithGrowth - this.record.annualValue
    const yearsOfGrowth = year - this.record.startAt.getFullYear()

    return formatKeyValue(`Growth Calculation (${year})`, [
      ['Base Value', `$${this.record.annualValue.toFixed(0)}`],
      ['Growth Rate', formatGrowthRate(this.record.growthRate)],
      ['Years', `${yearsOfGrowth} year${yearsOfGrowth !== 1 ? 's' : ''}`],
      ['Growth Amount', `+$${growthAmount.toFixed(0)}`],
      ['Final Value', `$${valueWithGrowth.toFixed(0)}`],
    ])
  }
}

export default TransactionGenerator
